module.exports = __webpack_public_path__ + "img/winner.9c1bf2ba.svg";